import { render } from "./FxTable.vue?vue&type=template&id=4dfc4df0"
import script from "./FxTable.vue?vue&type=script&lang=js"
export * from "./FxTable.vue?vue&type=script&lang=js"

import "./FxTable.vue?vue&type=style&index=0&id=4dfc4df0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__